import React, {Component} from "react";
import {inject, observer} from "mobx-react";
import {Button} from 'reactstrap';
import {LoadingBlockFields} from  "../../comum/components/LoadingBlockFields";
import {MensagemErro} from "../../comum/components/MensagemErro";
import DataWrapper from "../../principal/containers/DataWrapper";
import MotsAtivasStore from "../stores/MotsAtivasStore";
import {Filtro} from "../../comum/components/Filtro";
import moment from "moment";

const FILTROS = ["COMPETENCIA_MES_INICIO", "COMPETENCIA_MES_FIM"];
const VALIDACAO = ["DATA_FINAL_3_MESES", "COMPETENCIA_MES_INICIO_OBRIGATORIA", "COMPETENCIA_MES_FIM_OBRIGATORIA"];

@inject("store")
@DataWrapper
@observer
export class MotsAtivas extends Component {
    constructor(props) {
        super(props);
        this.controller = new MotsAtivasStore();
        this.tituloPaginaStore = this.props.store.tituloPaginaStore;
    }

    componentDidMount() {
        this.tituloPaginaStore.setTitulo("MOTs ativas");
    }

    render() {
        return (
            <div className="form-wrapper">
                <div className="content-panel">
                    <p style={{color: 'darkorange'}}>Atenção: Este relatório apresenta a posição das MOTs no dia anterior.</p>                    
                    <LoadingBlockFields carregando={this.controller.carregando}>
                        <Filtro history={this.props.history}
                                controller={this.controller}
                                location={this.props.location}
                                fields={FILTROS}
                                validations={VALIDACAO}
                                onExportExcel={(filtro) => this.controller.onExportExcel(filtro)}
                                inicialDataValue={moment()} />
                    </LoadingBlockFields>
                    { this.controller.erro
                        && <MensagemErro>
                            {this.controller.erro}
                        </MensagemErro>
                    }
                </div>
            </div>
        )
    }
}
